import api from './api'

// Sprints, the backlog and workflow rules of a project
export const sprintService = {
  getSprints: async (projectId, { includeClosed = false } = {}) => {
    const response = await api.get(`/projects/${projectId}/sprints`, { params: includeClosed ? { include_closed: true } : {} })
    return response.data
  },

  createSprint: async (projectId, data = {}) => {
    const response = await api.post(`/projects/${projectId}/sprints`, data)
    return response.data
  },

  updateSprint: async (projectId, sprintId, data) => {
    const response = await api.put(`/projects/${projectId}/sprints/${sprintId}`, data)
    return response.data
  },

  deleteSprint: async (projectId, sprintId) => {
    const response = await api.delete(`/projects/${projectId}/sprints/${sprintId}`)
    return response.data
  },

  startSprint: async (projectId, sprintId, data) => {
    const response = await api.post(`/projects/${projectId}/sprints/${sprintId}/start`, data)
    return response.data
  },

  // moveTo: 'backlog' | 'new' | <planned sprint id>
  completeSprint: async (projectId, sprintId, moveTo) => {
    const response = await api.post(`/projects/${projectId}/sprints/${sprintId}/complete`, { move_to: moveTo })
    return response.data
  },

  getBacklog: async (projectId) => {
    const response = await api.get(`/projects/${projectId}/backlog`)
    return response.data
  },

  // sprintId null = backlog; beforeTaskId places them above that task
  moveTasks: async (projectId, taskIds, sprintId, beforeTaskId) => {
    const response = await api.put(`/projects/${projectId}/backlog/move`, { task_ids: taskIds, sprint_id: sprintId, before_task_id: beforeTaskId })
    return response.data
  },

  getWorkflow: async (projectId) => {
    const response = await api.get(`/projects/${projectId}/workflow`)
    return response.data
  },

  setWorkflow: async (projectId, restricted, transitions) => {
    const response = await api.put(`/projects/${projectId}/workflow`, { restricted, transitions })
    return response.data
  }
}
